import turfFn from "@turf/point-on-feature";

export default function pointOnFeature(feature) {
    return turfFn(feature);
}
